<template>
  <div>
    <Row :gutter="16" style="margin-left:0;" type="flex">
      <Col style="margin-top:30px;padding:0 10px;" v-for="(item,index) in adminList" :key="index">
        <Card  :padding='0' style="width: 280px;height:360px">
          <div class="card-wrapper" @mouseover="cardHover(index)" @mouseout="cardOut(index)">
            <div class="iconfont icon-chushaixuanxiang icon-cha" v-show="item.showCha" @click="clickCha(index)"></div>
            <div class="imgbox">
              <div class="img">
                <img v-if="item.headPicUrl" :src="item.headPicUrl" />
                <img v-else src="../../../assets/images/default.png" />
              </div>
            </div>
            <div class="pname" v-if="item.userName">{{ item.userName }}</div>
            <div class="pname" v-else>姓名</div>
            <div class="from-wrapper">
              <div class="from slh" v-if="item.community">
                <span class="iconfont icon-shequ icon-community"></span>
                <span :title="item.community">{{item.community}}</span>
              </div>
              <div class="from slh " v-if="item.zone">
                <span class="iconfont icon-shouye icon-zone"></span>
                <span :title="item.zone">{{item.zone}}</span>
              </div>
              <div class="from slh" v-if="item.party">
                <span class="iconfont icon-dangzhibugongzuo icon-party"></span>
                <span :title="item.party">{{item.party}}</span>
              </div>
            </div>
          </div>
        </Card>
      </Col>
    </Row>
    <Modal
      v-model="showDel"
      :mask-closable="false"
      width="660"
      @on-ok="deladmin"
      @on-cancel="initdel"
    >
      <p slot="header" style="text-align: left">删除</p>
      <div class="tr">
        <div class="tr_title">管理权限</div>
        <Select v-model="delList" multiple class="box_f1">
          <Option v-for="item in delType" :value="item.zoneId" :key="item.zoneId">{{ item.zoneName }}</Option>
        </Select>
      </div>
      <!-- <div class="del-wrapper">
        <div
          v-for="(egg,ind) in delType"
          :key="ind"
          class="delItem-wrapper"
          :class="{isselect:egg.isSelect}"
          @click="clickDel(egg,ind)"
          >
          <img v-if="egg.isSelect" class="xuanzhong color" src="../../../assets/images/select.png">
          <div class="iconfont type-icon" :class="egg.icon"  :style="{color:(egg.isSelect?'#ff5740':'#cecece')}"></div>
          <div>{{egg.zoneName}}</div>
        </div>
      </div> -->
    </Modal>
  </div>
</template>

<script>
var that
export default {
  name: "sqfwCard",
  components: {
  },
  props: {
    spinShows: Boolean,
    adminList: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      showDel:false,
      delType:[],//要删除的管理员包含的社区类型
      delList:[],//要删除的类型
      delAdminId:'',
      newAdminList:[]
    }
  },
  watch: {
    adminList () {
      var old = that.adminList
      console.log(old)
      old.forEach(item => {
        var community = [] //社区
        var party = [] //微支部
        var zone = [] //小区
        var list = item.zoneList
        list.forEach(sub => {
          if (sub.zoneType == 0) {
            community.push(sub.zoneName)
          }else if (sub.zoneType == 1) {
            zone.push(sub.zoneName)
          }else {
            party.push(sub.zoneName)
          }
        })
        item.party = party.join(',')
        item.zone = zone.join(',')
        item.community = community.join(',')
      })
      that.newAdminList = old
      console.log(that.newAdminList)
    }
  },
  methods: {
    cardHover (index) {
      that.adminList[index].showCha = true
    },
    cardOut (index) {
      that.adminList[index].showCha = false
    },
    clickCha (index) {
      that.showDel = true
      that.delType = []
      that.delAdminId = that.adminList[index].unionId
      that.adminList[index].zoneList.forEach(item => {
        if (item.zoneType == 0) {
          that.delType.push({
            zoneType: 0,
            zoneId: item.zoneId,
            zoneName: item.zoneName,
            icon: 'icon-shequ',
            isSelect:false
          })
        }else if (item.zoneType == 1) {
          that.delType.push({
            zoneType: 1,
            zoneId: item.zoneId,
            zoneName: item.zoneName,
            icon: 'icon-shouye',
            isSelect:false
          })
        }else {
          that.delType.push({
            zoneType: 2,
            zoneId: item.zoneId,
            zoneName: item.zoneName,
            icon: 'icon-dangzhibugongzuo',
            isSelect:false
          })
        }
      })
      console.log(this.delType)
    },
    deladmin () {
      if (!that.delList.length) {
        that.$Message.warning('请选择行政区域')
        return
      }
      that.$emit("delAdmin",{
        delList:that.delList,
        unionId:that.delAdminId
      })
      that.initdel()
    },
    clickDel (item,index) {
      that.delType[index].isSelect = !that.delType[index].isSelect
      if (item.zoneType == 0) {
        var ind = that.delList.indexOf('-1')
        if (ind > -1) {
          that.delList.splice(ind,1)
          return
        }else {
          that.delList.push(-1)
        }
      }else {
        var id = item.zoneId
        var _ind = that.delList.indexOf(id)
        if (_ind > -1) {
          that.delList.splice(_ind,1)
          return
        }else {
          that.delList.push(item.zoneId)
        }
      }
    },
    initdel () {
      that.delType=[],
      that.delList=[],
      that.delAdminId=''
    }
  },
  created() {
    that = this;
  }
};
</script>

<style scoped>
  .imgbox{
    width:100%;
  }
  .img{
    padding: 45px 0 30px 100px;
  }
  .img img{
    width:80px;
    height:80px;
    border-radius:50%;
  }
  .pname{
    text-align:center;
    font-size:16px;
    color:#666666;
    padding-bottom: 55px;
    border-bottom: 1px solid #eee;
  }
  .from-wrapper{
    padding: 30px 20px 0 20px
  }
  .from{
    text-align: center;
    padding-bottom: 5px;
  }

  .card-wrapper{
    color: #4b4b4b;
    position: relative;
  }
  .icon-community{
    padding-right:5px;
    color:#cdcdcd;
  }
  .icon-party{
    padding-right: 5px;
    color: #ff5740
  }
  .icon-zone{
    padding-right: 5px;
    color: #cfcfcf
  }
  .icon-cha{
    position: absolute;
    right:10px;
    top: 10px;
    color: #cdcdcd;
    font-size: 18px
  }
  .del-wrapper{
    height: 340px;
    display: flex;
    flex-wrap: wrap;
  }
  .delItem-wrapper{
    height:150px;
    width: 120px;
    display: flex;
    flex-flow: column;
    justify-content:center;
    text-align: center;
    border:1px solid #e5e5e5;
    border-radius: 7px;
    margin-right:20px;
    margin-bottom: 30px;
    position: relative;
  }
  .type-icon{
    margin-bottom: 20px;
  }
  .xuanzhong{
    position: absolute;
    top: -10px;
    right: -10px;
    height: 20px;
    width: 20px;
  }
  .isselect{
    border:2px solid #ff7b44;
  }
  .tr{
    width: 100%;
    display: flex;
    line-height: 36px;
    height: 370px;
    
  }
  .tr_title{
        margin-right: 20px;
        width: 60px;
    }
</style>
